import React from "react";
import Table from "../Table";
import moment from "moment";

const title = "Application Details";
const columns = [
  {
    name: "Status",
    selector: "status",
    sortable: false,
    width: "12%"
  },
  {
    name: "Additional Status",
    selector: "additionalStatus",
    sortable: false,
    width: "24%"
  },
  {
    name: "Submission Date",
    selector: "submissionDate",
    sortable: false,
    cell: row => {
      return (
        <span>
          {moment
            .utc(row.submissionDate)
            .local()
            .format("MM-DD-YYYY HH:mm")}
        </span>
      );
    },
    width: "17%"
  },
  {
    name: "Completion Date",
    selector: "completionDate",
    sortable: false,
    cell: row => {
      return (
        <span>
          {moment
            .utc(row.completionDate)
            .local()
            .format("MM-DD-YYYY HH:mm")}
        </span>
      );
    },
    width: "17%"
  },
  {
    name: "Months Processed",
    selector: "retrievalIntervalMonths",
    sortable: false,
    width: "5%"
  }
];

function AUApplicationTable(props) {
  return (
    <Table
      title={title}
      columns={columns}
      data={props.data}
      pagination={false}
    />
  );
}

export default AUApplicationTable;
